<template>
  <v-sheet
    class="px-4 py-4"
  >
    <v-card-text v-if="modalData.reportPath === 'all-data'">
      This report represents a base report from which all other reports inherit.
    </v-card-text>

    <v-card-text v-else-if="modalData.reportPath === 'at-risk'">
      <p>
        At Risk line items are those that potentially will not deliver their
        scheduled impression goal in full by their end date. At Risk Line
        items are those that are delivering impressions AND have an OSI less
        than 100 as of the last data refresh time.
      </p>

      <p>
        Archived line items are excluded from all current reports.
      </p>
    </v-card-text>

    <v-card-text v-else-if="modalData.reportPath === 'ending-soon'">
      <p>
        The Ending Soon report uses the following data parameters:
      </p>

      <p>
        Any currently delivering line items that will be ending within
        the next 3 days (today + 3)
      </p>

      <p>OR</p>

      <p>
        Any other line items that still have a status of DELIVERING
        in GAM with end dates within the last 4 days (today - 4)
      </p>

      <p>
        Archived line items are excluded from all current reports.
      </p>
    </v-card-text>

    <v-card-text v-else-if="modalData.reportPath === 'started-yet-paused'">
      <p>
        Displays all line items that started within the
        last 14 days but whose status remains PAUSED.
      </p>

      <p>
        Archived line items are excluded from all current reports.
      </p>
    </v-card-text>

    <v-card-text v-else-if="modalData.reportPath === 'started-yet-ready'">
      <p>
        Displays all line items that started within the
        last 14 days but whose status remains READY.
      </p>

      <p>
        Archived line items are excluded from all current reports.
      </p>
    </v-card-text>

    <v-card-text v-else-if="modalData.reportPath === 'zero-delivery-yesterday'">
      <p>
        Displays all line items with status of DELIVERING that
        delivered zero impressions yesterday. This excludes
        line items that are only set up for click tracking.
      </p>

      <p>
        Archived line items are excluded from all current reports.
      </p>
    </v-card-text>

    <v-card-text v-else-if="modalData.reportPath === 'missing-creatives'">
      <p>
        Displays all DELIVERING line items that are missing
        at least one creative AND all READY line items that
        are missing at least one creative whose start dates
        are in the past or within the next 14 days.
      </p>

      <p>
        Archived line items are excluded from all current reports.
      </p>
    </v-card-text>

    <v-card-text v-else>
      <p v-if="modalData.groupKey === 'global'">
        This report is a global template.
      </p>
      <p v-if="modalData.groupKey === 'owner'">
        You are this report's owner.
      </p>
      <p v-if="modalData.groupKey === 'shared'">
        This report was shared with you.
      </p>
      <p v-if="modalData.groupKey === 'team'">
        This report was made available to your team.
      </p>
    </v-card-text>
  </v-sheet>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'

const { mapState: mapReportState } = createNamespacedHelpers('report')

export default {
  name: 'ReportInfo',
  computed: {
    ...mapReportState({
      modalData: (state) => state.modalData,
    }),
  },
}
</script>
